import { useMutation } from '@tanstack/react-query';
import { deleteAdminFeedbackCycle } from './requests';

const useDeleteAdminFeedbackCycle = () =>
  useMutation({
    mutationFn: deleteAdminFeedbackCycle,
  });

export default useDeleteAdminFeedbackCycle;